'use client';

import { usePrevious } from '@nf/utils-common/hooks';
import { useEffect, useRef, useState } from 'react';

// 直欄一組
type ScoreboardColumnProps = {
	heading?: any;
	cells?: any;
	matchid?: number;
};

export const ScoreboardColumn = ({ heading, cells, matchid }: ScoreboardColumnProps) => {
	return (
		<>
			<ScoreboardHead key={`${heading}Head`} text={heading} />
			{cells.map((cell: { text: string, scored: boolean }, index: any) => (
				<ScoreboardCell key={`ScoreboardColumn${matchid}${index}`} text={cell.text} />
			))}
		</>


	)
};

// 單一格子
type ScoreboardCellProps = {
	text?: string;
	cells?: any;
};



const ScoreboardHead = ({ text }: ScoreboardCellProps) => {
	return (
		<div className="scoreboard__cell-heading">
			<span className="scoreboard__text">
				{text}
			</span>
		</div>
	);
}

const ScoreboardCell = ({ text }: ScoreboardCellProps) => {

	const score = Number(text) ?? 0;
	const previousPoint = usePrevious<number>(score) ?? 0;
	const [isScored, setIsScored] = useState(false);
	const timerRef = useRef<ReturnType<typeof setTimeout>>();
	useEffect(() => {
		const isPointChange = previousPoint !== Number(text)
		if (!isPointChange || previousPoint === 0) {
			return;
		}

		clearTimeout(timerRef.current);
		setIsScored(true);
		timerRef.current = setTimeout(() => {
			setIsScored(false);
		}, 3000);

		return () => {
			clearTimeout(timerRef.current);
		};

	}, [text]);



	return (
		<div className="scoreboard__cell">
			<span
				className="scoreboard__text"
				data-scored={isScored}
			>
				{text}
			</span>
		</div>
	);
}

